import ClickAwayListener from "@mui/material/ClickAwayListener";
import { ChevronDown } from "lucide-react";
import { useRef, useState } from "react";
import { DropdownPortal } from "./DropdownPortal";

export const TEXT_COLORS = [
	{ label: "Domyślny", value: null },
	{ label: "Czarny", value: "#000000" },
	{ label: "Szary", value: "#6b7280" },
	{ label: "Brązowy", value: "#92400e" },
	{ label: "Pomarańczowy", value: "#ea580c" },
	{ label: "Żółty", value: "#ca8a04" },
	{ label: "Zielony", value: "#16a34a" },
	{ label: "Morski", value: "#0d9488" },
	{ label: "Niebieski", value: "#2563eb" },
	{ label: "Indygo", value: "#4f46e5" },
	{ label: "Fioletowy", value: "#7c3aed" },
	{ label: "Różowy", value: "#db2777" },
	{ label: "Czerwony", value: "#dc2626" },
	{ label: "Biały", value: "#ffffff" },
	{ label: "Granatowy", value: "#1e3a5f" },
	{ label: "Ciemnozielony", value: "#166534" },
];

export const BG_COLORS = [
	{ label: "Brak", value: null },
	{ label: "Żółty", value: "#fef9c3" },
	{ label: "Zielony", value: "#dcfce7" },
	{ label: "Niebieski", value: "#dbeafe" },
	{ label: "Fioletowy", value: "#ede9fe" },
	{ label: "Różowy", value: "#fce7f3" },
	{ label: "Czerwony", value: "#fee2e2" },
	{ label: "Pomarańczowy", value: "#ffedd5" },
	{ label: "Szary", value: "#f3f4f6" },
	{ label: "Morski", value: "#ccfbf1" },
	{ label: "Indygo", value: "#e0e7ff" },
	{ label: "Brązowy", value: "#fef3c7" },
	{ label: "Ciemnoszary", value: "#e5e7eb" },
	{ label: "Miętowy", value: "#d1fae5" },
	{ label: "Lawendowy", value: "#f3e8ff" },
	{ label: "Łososiowy", value: "#ffe4e6" },
];

export function ToolbarSeparator() {
	return <div className="tiptap-toolbar__separator" />;
}

export function ColorPickerDropdown({ colors, icon, title, onSelect }) {
	const [open, setOpen] = useState(false);
	const btnRef = useRef(null);

	return (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<div className="tiptap-toolbar__dropdown-wrapper">
				<button
					ref={btnRef}
					type="button"
					className="tiptap-toolbar__btn tiptap-toolbar__btn--dropdown"
					onClick={() => setOpen(!open)}
					title={title}
				>
					{icon}
					<ChevronDown size={12} />
				</button>
				<DropdownPortal anchorRef={btnRef} open={open} className="tiptap-toolbar__dropdown tiptap-color-grid">
					{colors.map((c) => (
						<button
							key={c.label}
							type="button"
							className="tiptap-color-swatch"
							style={{ background: c.value || "transparent" }}
							title={c.label}
							onClick={() => {
								onSelect(c.value);
								setOpen(false);
							}}
						>
							{!c.value && (
								<span className="tiptap-color-swatch__none">✕</span>
							)}
						</button>
					))}
				</DropdownPortal>
			</div>
		</ClickAwayListener>
	);
}
